(() => {
  if (customElements.get('gem-product-demo')) return;
  class GemProductDemo extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.gem-demo__toggle');
      this.message = this.querySelector('.gem-demo__message');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.manualPlay = false;
      this.systemPause = false;
      this.failed = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.manualPlay = true;
          if (this.failed) this.prepared = false;
          this.failed = false;
          this.start();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.video.addEventListener('play', () => {
        if (!this.visible || document.hidden) { this.stop(); return; }
        this.button.textContent = 'Pause video';
        this.message.textContent = '';
      }, options);
      this.video.addEventListener('pause', () => {
        this.button.textContent = 'Play video';
        if (!this.systemPause && this.visible && !document.hidden) this.userPaused = true;
        this.systemPause = false;
      }, options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.button.textContent = 'Retry video';
        this.message.textContent = 'The video could not load. You can try again.';
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
          this.sync();
        }, { threshold: [0, 0.35] });
        this.observer.observe(this.video);
      } else {
        // Keep a manual player available if viewport observation is unsupported.
        this.visible = true;
        this.userPaused = true;
        this.prepare();
      }
    }
    prepare() {
      if (this.prepared && !this.failed) return;
      const sources = [...this.video.querySelectorAll('source[data-src]')];
      const desiredHeight = this.video.clientWidth <= 800 ? 720 : 1080;
      const ordered = sources.sort((a, b) => Number(a.dataset.height) - Number(b.dataset.height));
      const selected = ordered.find(s => Number(s.dataset.height) >= desiredHeight) || ordered[ordered.length - 1];
      if (selected) this.video.src = selected.dataset.src;
      this.video.load();
      this.prepared = true;
    }
    start() {
      this.prepare();
      const attempt = this.video.play();
      if (attempt && attempt.then) attempt.then(() => {
        if (!this.visible || document.hidden || this.userPaused) this.stop();
      }).catch(error => {
        if (error.name === 'AbortError') return;
        this.userPaused = true;
        this.button.textContent = 'Play video';
        this.message.textContent = 'Press play to watch the demonstration.';
      });
    }
    stop() {
      if (!this.video.paused) {
        this.systemPause = true;
        this.video.pause();
      }
    }
    sync() {
      if (!this.visible || document.hidden) { this.stop(); return; }
      this.prepare();
      const saveData = navigator.connection && navigator.connection.saveData;
      if (!this.userPaused && !this.failed && ((!this.motion.matches && !saveData) || this.manualPlay)) {
        this.start();
      } else if ((this.motion.matches || saveData) && !this.manualPlay) this.stop();
    }
    disconnectedCallback() {
      if (!this.abort) return;
      this.stop();
      this.abort.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  }
  customElements.define('gem-product-demo', GemProductDemo);
})();
